import ContactRequestList from './ContactRequestList'
import ContactRequestEdit from './ContactRequestEdit'
import ContactRequestIcon from '@material-ui/icons/AllInbox';

export default {
  list: ContactRequestList,
  edit: ContactRequestEdit,
  icon: ContactRequestIcon,
  options: { label: 'Contact Request' }
}